(function() {
    'use strict';

    angular
        .module('masterApp')
        .controller('OfficeDialogController', OfficeDialogController);

    OfficeDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'DataUtils', 'entity', 'Office','GLOBAL_URL','$state','$http','$filter','CommonService'];

    function OfficeDialogController ( $timeout, $scope, $stateParams, $uibModalInstance, DataUtils, entity, Office, GLOBAL_URL,$state,$http,$filter,CommonService) {
        var vm = this;
        vm.lstArea = CommonService.query({masterurl:'area'});
        vm.lstTransportType = CommonService.query({masterurl:'transport-type'});
        vm.office = entity;
        vm.clear = clear;
        vm.byteSize = DataUtils.byteSize;
        vm.openFile = DataUtils.openFile;
        vm.save = save;
        vm.checkcreat = false;
        if (vm.office.officeCode != null || vm.office.officeCode != undefined) {
       	 vm.checkcreat = true;
       	vm.office.isExit = true;
       }else{
    	   vm.office.isExit = false;
    	   vm.office.beginDate = new Date();
           vm.office.endDate = new Date();
           vm.office.status = "0";
       }
        if (vm.office.endDate != null || vm.office.endDate != undefined) {
        	  vm.statusEnd = true;
          }else{
        	  vm.statusEnd = false;
          }
        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
        	$scope.clearMessage();
            vm.isSaving = true;
            if (vm.statusEnd != true) {
            	vm.office.endDate = null;
              }
            if (vm.office.isExit == true) {
            	Office.update(vm.office,function(result){
          		  $scope.$emit('masterApp:officeUpdate', result);
                  $uibModalInstance.close(result);
                  vm.isSaving = false;
        	},function(error) {
        		vm.isSaving = false;
        	});
            } else {
            	Office.save(vm.office,function(result){
        		  $scope.$emit('masterApp:officeUpdate', result);
                  $uibModalInstance.close(result);
                  vm.isSaving = false;
            	},function(error) {
            		vm.isSaving = false;
    		});
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('masterApp:officeUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }
        function onSaveError () {
            vm.isSaving = false;
        }
        vm.openFromDate = function() {
    		vm.popupFromDate.opened = true;
    	};
    	vm.openToDate = function() {
    		vm.popupToDate.opened = true;
    	};
    	$scope.formats = [ 'dd-MMMM-yyyy', 'yyyy/MM/dd', 'dd/MM/yyyy',
    			'shortDate' ];
    	$scope.format = $scope.formats[2];
    	$scope.altInputFormats = [ 'dd/MM/yyyy' ];

    	vm.popupFromDate = {
    		opened : false
    	};

    	vm.popupToDate = {
    		opened : false
    	};
    	vm.dateOptions = {
    		    maxDate: new Date()
    		  };
    	vm.validateDates =function () {
			$scope.clearMessage();
			
    	    var currentDate = new Date();
    	        var toDate = moment($scope.vm.office.endDate,"DD/MM/YYYY");
    	        var fromDate = moment($scope.vm.office.beginDate,"DD/MM/YYYY");
    	        if (currentDate < toDate){
    	        	vm.checkDate = true;
    	        	$scope.addAlert('Vui lòng chọn Đến Ngày bằng hoặc nhỏ hơn ngày hiện tại.','error');
    	        }else if (currentDate < fromDate){
        	        	vm.checkDate = true;
        	        	$scope.addAlert('Vui lòng chọn Từ Ngày bằng hoặc nhỏ hơn ngày hiện tại.','error');
        	    }else if (toDate.diff(fromDate) < 0){
    	        	vm.checkDate = true;
    	        	$scope.addAlert('Vui lòng chọn Đến Ngày lớn hơn hoặc bằng Từ ngày.','error');
    	        }else{
    	        	vm.checkDate = false;
    	        }
	    	};



    }
})();
